import { COOKIES } from "@/constants/cookies";
import axios from "axios";
import { parseCookies } from "nookies";
import { handleUnauthorized } from "@/utils/auth-utils";

export const apiLegacy = axios.create({
  baseURL: import.meta.env.VITE_LEGACY_API,
});

apiLegacy.interceptors.request.use((config) => {
  let authCookie = parseCookies()[COOKIES.BACKOFFICE_AUTH];

  if (!authCookie) {
    authCookie = parseCookies()[COOKIES.U_TOKEN];
  }

  if (authCookie) {
    config.headers["auth-token"] = authCookie;
    config.headers["Authorization"] = `Bearer ${authCookie}`;
  }

  return config;
});

apiLegacy.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      handleUnauthorized();
    }
    return Promise.reject(error);
  },
);
